import { ArrowLeft } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { returnToUsers } from "../../lib/dashboard-session";

export function DashboardAccessBanner() {
  const { dashboardSession } = useAuth();
  if (!dashboardSession) return null;
  return (
    <div role="status" className="sticky top-0 z-50 flex h-12 items-center justify-between gap-3 border-b border-violet-200 bg-violet-50 px-4 text-sm text-violet-950">
      <span className="truncate">Viewing dashboard: <strong>{dashboardSession.userLabel}</strong></span>
      <button type="button" onClick={returnToUsers} className="flex shrink-0 items-center gap-2 rounded-md bg-violet-700 px-3 py-1.5 font-medium text-white hover:bg-violet-800">
        <ArrowLeft className="h-4 w-4" /> Back to Users
      </button>
    </div>
  );
}
